import * as React from 'react';
import { Container } from 'semantic-ui-react';
import { useRequireAccessToken } from '~/Application/useRequireAccessToken';
import * as Routes from '~/Application/routes';
import { ErrorConsumer } from '~/ErrorHandler';
import { Login } from '~/Impersonate';
import { ErrorAlert, Placeholder } from '~/UI';
export var Impersonate = function () {
    var accessToken = useRequireAccessToken()[0];
    var redirectToDashboard = Routes.DashboardRoute.useRedirect();
    var complete = function () {
        redirectToDashboard({ replace: true });
    };
    return (<Container>
			<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
			{accessToken.isLoading ? <Placeholder /> : null}
			{accessToken.value !== null ? <Login accessToken={accessToken.value} onComplete={complete}/> : null}
		</Container>);
};
